import React, { useState } from 'react';
import {
  StyledHeader,
  StyledMessage,
  StyledMessageContent,
  StyledModalContent,
  StyledNotificationContainer
} from './style';
import { StyledDiv, StyledSpan } from '../../../Theme/CommonStyled';
import Icon from '../../Common/Icon';
import { NotificationDataType } from '../../../Types/notification.type';
import Modal from '../../Common/Modal';
import Title from '../../Common/Title';
import { useTranslation } from 'react-i18next';

type NotificationItemType = {
  data: NotificationDataType;
};
const NotificationItem: React.FC<NotificationItemType> = ({ data }) => {
  const { t } = useTranslation();

  const [showModal, setShowModal] = useState(false);
  const [smsId, setSmsId] = useState(null);

  const { dateTime } = data;
  const smsDate = new Date(dateTime);

  return (
    <>
      {smsId === data.smsId && (
        <Modal open={showModal} setOpen={setShowModal}>
          <>
            {(data.iconUrl || data.title) && (
              <StyledModalContent>
                <Icon name={data.iconUrl} fontSize={8} ml={6} />
                <StyledDiv color="normalText" fontSize={4}>
                  {data.title}
                </StyledDiv>
              </StyledModalContent>
            )}
            <StyledDiv display="flex" gap={12}>
              <StyledModalContent
                flex={1}
                display="flex"
                justifyContent="center"
                color="secondaryText"
                letterSpacing="0.3rem">
                <StyledSpan>
                  <Icon name="clock" mr={7} fontSize={6} color="primaryBlue" />
                  {smsDate.toLocaleString('fa-IR', {
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </StyledSpan>
              </StyledModalContent>
              <StyledModalContent
                flex={3}
                color="secondaryText"
                justifyContent="flex-end"
                letterSpacing="0.3rem">
                {smsDate.toLocaleString('fa-IR', {
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                  calendar: 'persian'
                })}
                <Icon
                  name="calendar_month"
                  mr={7}
                  fontSize={6}
                  color="primaryBlue"
                />
              </StyledModalContent>
            </StyledDiv>
            <Title title={t('notification.notificationMessage')} mb={7} />
            <StyledModalContent
              type={'message'}
              color="normalText"
              flexDirection="column"
              alignItems="flex-start !important">
              {data.message.split('\n').map((item) => (
                <StyledMessageContent key={item}>{item}</StyledMessageContent>
              ))}
            </StyledModalContent>
          </>
        </Modal>
      )}
      <StyledNotificationContainer
        onClick={async () => {
          setSmsId(data.smsId);
          setTimeout(() => {
            setShowModal(true);
          });
        }}>
        {(data.iconUrl || data.title) && (
          <StyledHeader>
            {/*Todo: show the icons when ready */}
            {/*<Icon name={data.iconUrl} fontSize={8} ml={6} />*/}
            <StyledDiv color="normalText" fontSize={4} ml={6}>
              {data.title}
            </StyledDiv>
            {data.secondTitle && (
              <StyledDiv
                color="secondaryText"
                pr={6}
                borderRight={0}
                borderColor="minorText"
                lineHeight="18px">
                {data.secondTitle}
              </StyledDiv>
            )}
          </StyledHeader>
        )}
        <StyledMessage>{data.message}</StyledMessage>
      </StyledNotificationContainer>
    </>
  );
};

export default NotificationItem;
